import { Method, send } from "./MyHttp";

/**
 * 리스트
 */
export const GetList = (params, success, fail) => {
    let paramsT = { ...params };
    if (params.title === "") delete paramsT["title"];
    if (params.content === "") delete paramsT["content"];
    if (params.name === "") delete paramsT["name"];

    send(Method.GET, "/board", paramsT, success, fail);
};

/**
 * 정보
 */
export const Get = (id, success, fail) => {
    const params = {};
    send(Method.GET, "/board/" + id, params, success, fail);
};

/**
 * 리스트
 */
export const GetRequest = (params, success, fail) => {
    let paramsT = { ...params };

    send(Method.GET, "/board/my/request", paramsT, success, fail);
};

/**
 * 등록
 */
export const Create = (params, success, fail) => {
    const paramsT = {
        board: params.board,
        public: params.public,
        type: params.type,
        name: params.name,
        email: params.email,
        phone: params.phone,
        tel: params.tel,
        password: params.password,
        title: params.title,
        contents: params.contents,
        uploadFiles: params.uploadFiles + "",
        requestID: params.requestID
    };

    send(Method.POST, "/board/", paramsT, success, fail);
};
